import { Pane } from 'tweakpane';
import { create } from 'zustand';

interface StoreState {
  pane: Pane | null;
  isPaneVisible: boolean;
  initPane: () => void;
  togglePaneVisibility: () => void;
}

export const useAppStore = create<StoreState>((set, get) => ({
  pane: null,
  isPaneVisible: false,
  initPane: () => {
    const container = document.getElementById('tweakpane-container');
    if (!container) {
      console.error('Tweakpane container not found');
      return;
    }

    const pane = new Pane({ container });
    set({ pane });

    pane.hidden = true;
  },
  togglePaneVisibility: () => {
    const { pane, isPaneVisible } = get();
    if (pane) {
      pane.hidden = !isPaneVisible;
      set({ isPaneVisible: !isPaneVisible });
    }
  },

  // fetchStyleFilterData: async () => {
  //   const response = await fetch('URL_ADDRESS');
  //   const data = await response.json();
  //   set({ styleFilterData: data });
  // }
}));
